export default __webpack_public_path__ + "static/media/clock.54856b5d.svg";